import { FC } from 'react';
import classNames from 'classnames';
import swiperCss from '@edikk-edikk/country-common/css/modules/swiper.module.scss';
import { AdvertPhotoType } from '@edikk-edikk/country-common';
import { AdvertPictureForPhoto } from '@edikk-edikk/country-layout-black';
import galleryThumbnailCss from '../../../assets/gallery/gallery-thumbnail.module.scss';

type PropsType = {
  photo: AdvertPhotoType;
  index: number;
  isActive: boolean;
};

const Thumbnail: FC<PropsType> = ({
  photo,
  index,
  isActive,
}) => (
  <div
    className={classNames(
      swiperCss.swiper__slide,
      galleryThumbnailCss.galleryThumbnail,
      { [galleryThumbnailCss.galleryThumbnail_active]: isActive },
    )}
  >
    <AdvertPictureForPhoto
      photo={photo}
      className={galleryThumbnailCss.galleryThumbnail__image}
      alt={`Preview for photo ${index + 1}`}
      isUse100
    />
  </div>
);

export { Thumbnail };
